var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { replaceEmptySpaces } from '@bestadapted/utility';
import { MDCRipple } from '@material/ripple';
import classNames from 'classnames';
import React from 'react';
import { style } from 'typestyle';
import './button.css';
var Button = /** @class */ (function (_super) {
    __extends(Button, _super);
    function Button() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.initRipple = function (buttonEl) {
            if (buttonEl)
                _this.ripple = new MDCRipple(buttonEl);
        };
        return _this;
    }
    Button.prototype.componentWillUnmount = function () {
        if (this.ripple)
            this.ripple.destroy();
    };
    Button.prototype.render = function () {
        var _a = this.props, adapter = _a.adapter, value = _a.value, className = _a.className, icon = _a.icon, isTrailingIcon = _a.isTrailingIcon, svg = _a.svg, children = _a.children, disabled = _a.disabled, buttonStyle = _a.style, title = _a.title, fullWidth = _a.fullWidth, onClick = _a.onClick, textTransform = _a.textTransform;
        var classes = classNames('mdc-button mdc-button--touch ba-mdc-button', {
            'mdc-button--outlined': adapter === 'outlined',
            'mdc-button--raised': adapter === 'raised',
            'mdc-button--unelevated': adapter === 'unelevated'
        }, className, fullWidth ? style({ width: '100%' }) : '', textTransform ? style({ textTransform: textTransform }) : '');
        return (React.createElement("div", { className: "mdc-touch-target-wrapper", "aria-describedby": this.props['aria-describedby'] },
            React.createElement("button", { className: classes, ref: this.initRipple, disabled: disabled, title: title, style: buttonStyle, onClick: onClick, "data-testid": replaceEmptySpaces(value !== null && value !== void 0 ? value : '') },
                React.createElement("span", { className: "mdc-button__ripple" }),
                renderIcon(children, isTrailingIcon, value, icon, svg),
                React.createElement("div", { className: "mdc-button__touch" }))));
    };
    Button.displayName = 'ba-button';
    return Button;
}(React.Component));
export { Button };
var renderIcon = function (children, isTrailingIcon, value, icon, svg) { return (React.createElement(React.Fragment, null,
    (icon || svg || children) && isTrailingIcon !== true
        ? getIcon(children, icon, svg)
        : null,
    React.createElement("span", { className: "mdc-button__label", title: value }, value),
    (icon || svg || children) && isTrailingIcon === true
        ? getIcon(children, icon, svg)
        : null)); };
var getIcon = function (children, iconName, svg) {
    if (svg) {
        return getSVGPath(svg);
    }
    else if (children) {
        return children;
    }
    else {
        return React.createElement(Icon, { name: iconName, className: "mdc-button__icon" });
    }
};
export var Icon = function (props) { return (React.createElement("i", { className: "material-icons " + (props.className ? props.className : ''), "aria-hidden": "true" }, props.name)); };
var getSVGPath = function (svg) { return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", role: "img", viewBox: "0 0 24 24", className: "mdc-button__icon" },
    React.createElement("path", { d: svg }))); };
//# sourceMappingURL=Button.js.map